import { HeadingProps } from '@wix/design-system';
import { NoFilterResultsBanner } from '../NoFilterResultsBanner';
import { NoSearchResultsBanner } from '../NoSearchResultsBanner';
import s from './EmptyStateBannerWrapper.module.scss';

export const EMPTY_STATE_BANNER_TYPES = {
  search: 'search',
  filter: 'filter',
} as const;

type EmptyStateBannerTypes =
  (typeof EMPTY_STATE_BANNER_TYPES)[keyof typeof EMPTY_STATE_BANNER_TYPES];

interface EmptyStateBannerWrapperProps {
  type?: EmptyStateBannerTypes;
  isMobileView?: boolean;
}

export const EmptyStateBannerWrapper = ({
  type,
  isMobileView,
}: EmptyStateBannerWrapperProps) => {
  const headingProps = isMobileView ? ({ size: 'medium' } as HeadingProps) : {};
  const className = isMobileView ? s.mobileBanner : undefined;

  if (type === EMPTY_STATE_BANNER_TYPES.filter) {
    return (
      <NoFilterResultsBanner
        headingProps={headingProps}
        className={className}
      />
    );
  }

  if (type === EMPTY_STATE_BANNER_TYPES.search) {
    return (
      <NoSearchResultsBanner
        headingProps={headingProps}
        className={className}
      />
    );
  }

  return null;
};
